import loadable from '../../utils/lazy/loadable';

export default loadable(() => import(/* webpackChunkName: "CalendarPage" */ './CalendarPage'));
